import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import { getEnvironment, getSentryDsn, getVersion } from '@/utils/env-utils.ts';

Sentry.init({
    dsn: getSentryDsn(),

    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    environment: getEnvironment(),
    release: `eh-practitioners-app@${getVersion()}`,
    enabled: !!getSentryDsn(),
    integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
            // eslint-disable-next-line no-restricted-syntax
            useEffect: React.useEffect,
            useLocation: useLocation,
            useNavigationType: useNavigationType,
            createRoutesFromChildren: createRoutesFromChildren,
            matchRoutes: matchRoutes,
        }),
    ],
    tracesSampleRate: 1,
    // tracePropagationTargets: ['localhost', /^https:\/\/([a-z0-9-]+\.)*eterno-health\.io(\/|$)/i], // can only be activated when headers are allowed in api
});
